export default "__VITE_ASSET__c42a77bc__"